import { useState } from 'react';
import PropTypes from 'prop-types';
import Button from 'Components/Atoms/Button/Button';
import { useTranslation } from 'react-i18next';

export default function ConfirmDialogContent(props) {
    const { onClose, onSubmit, title, description, icon, confirmText, cancelText } = props;

    const { t } = useTranslation('common');
    const [isBusy, setIsBusy] = useState(false);

    const resolvedConfirmText = confirmText || t('confirm');
    const resolvedCancelText = cancelText || t('cancel');

    const handleConfirm = async () => {
        setIsBusy(true);
        try {
            await onSubmit?.();
        } finally {
            setIsBusy(false);
        }
    };

    return (
        <div className="py-8 md:py-10 px-2 md:px-6">
            <div className="text-center flex flex-col items-center gap-3 mb-8">
                {icon && <div className="flex justify-center mb-2">{icon}</div>}
                {title && <div className="text-xl font-semibold text-dark-blue">{title}</div>}
                {description && <div className="text-gray-500 text-pretty text-lg">{description}</div>}
            </div>
            <div className="flex justify-evenly gap-3">
                <Button variant="primary" onClick={handleConfirm} className="grow" isBusy={isBusy}>
                    {resolvedConfirmText}
                </Button>
                <Button onClick={onClose} className="grow" disabled={isBusy}>
                    {resolvedCancelText}
                </Button>
            </div>
        </div>
    );
}

ConfirmDialogContent.propTypes = {
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    description: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    icon: PropTypes.node,
    confirmText: PropTypes.string,
    cancelText: PropTypes.string,
};

ConfirmDialogContent.dialogProps = {
    size: 'sm',
};
